import { Component, Input, OnInit } from '@angular/core';
import { TranslateService, Translation } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ePrescription } from '@core/classes/tables/eprescription';

@UntilDestroy()
@Component({
  selector: 'ncp-eprescription-details',
  imports: [],
  templateUrl: './eprescription-details.component.html',
})
export class EprescriptionDetailsComponent implements OnInit {
  @Input() item!: ePrescription;

  protected translations!: Translation;

  constructor(
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.translations = this.translate.instant('tables.ePrescriptions.ePrescriptionDetails');

    this.translate.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.translations = this.translate.instant('tables.ePrescriptions.ePrescriptionDetails');
      });
  }

  protected isDispensed(): boolean {
    return Number(this.item.status) === 3 && !!this.item.extra_info;
  }

  protected formatDate(date?: string): string {
    if (!date) return '';

    const d = new Date(date);

    if (isNaN(d.getTime())) {
      return date;
    }

    return d.toLocaleDateString('en-GB');
  }
}
